import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RootStoreStateModule } from './store';
import { CoreModule } from './modules/core/core.module';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { AuthGuard } from './_helpers/auth.guard';
import { PermissionsGuard } from './_helpers/permissions.guard';
import { AuthService } from './services/auth.service';
import { HttpTokenInterceptor } from './_helpers/http.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackBarService } from './services/snackbar.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LoaderInterceptor } from './_helpers/loader.interceptor';
import { TreeComponent } from './modules/admin/editor/tree/tree.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkContextMenuTrigger, CdkMenuTrigger, CdkMenuItem, CdkMenu } from '@angular/cdk/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CoreRoutingModule } from './modules/core/core-routing.module';
import { ResizableDirective } from './directives/resizable.directive';
import { BreadcrumbComponent } from './modules/admin/breadcrumb/breadcrumb.component';
import { LocalStorageService } from './services/local-storage.service';
import { STORAGE_PROVIDER, StorageProvider } from './store/localStorage/local-storage.interface';
import { LocalStorageProvider } from './store/localStorage/local-storage.provider';
import { provideTranslateService, TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
export function autoLoginFactory(authService: AuthService) {
  return () => authService.autoLogin();
}

@NgModule({
  declarations: [
    AppComponent,
    TreeComponent
  ],
  imports: [
    AuthenticationModule,
    BrowserModule,
    AppRoutingModule,
    CoreRoutingModule,
    RootStoreStateModule,
    CoreModule,
    RootStoreStateModule,
    MatProgressBarModule,
    MatTreeModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    DragDropModule,
    CdkContextMenuTrigger,
    CdkMenuItem,
    CdkMenu,
    CdkMenuTrigger,
    HttpClientModule,
    MatSnackBarModule,
    NgbDropdownModule,
    ResizableDirective,
    BreadcrumbComponent,
    TranslateModule.forRoot({
      defaultLanguage: 'en'
    }),
    BsDropdownModule.forRoot()
  ],
  providers: [provideHttpClient(), {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpTokenInterceptor,
    multi: true,
    deps: [AuthService]
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true
  }, AuthGuard, PermissionsGuard, {
    provide: APP_INITIALIZER,
    useFactory: autoLoginFactory,
    deps: [AuthService],
    multi: true,
  }, SnackBarService, provideAnimations(),
    LocalStorageService,
  {
    provide: STORAGE_PROVIDER,
    useClass: LocalStorageProvider
  },
  provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json',
    }),
    fallbackLang: 'en',
    lang: 'en'
  })],
  bootstrap: [AppComponent]
})
export class AppModule { }
